import { get } from '../lib/api/client';

/**
 * GET /ping response shape.
 *
 * `version` is the BE API version (or "UNKNOWN" in debug builds).
 *
 * `appVersionRequired` is the optional FE minimum-version contract. When
 * present (and matching `MAJOR.MINOR.PATCH` server-side, which the BE
 * regex-guards), the FE is expected to refuse to keep running if
 * `VITE_VERSION` is strictly less than this value — see
 * `versionCheckService.runVersionCheck()`. Absent means "no hard cutoff
 * in effect" and the FE proceeds normally.
 */
export interface PingResponse {
  pong: string;
  version: string;
  /** Consumer app's floor — ignored by the admin app. */
  appVersionRequired?: string;
  /**
   * The admin app's own floor (api-core-go `appVersionRequiredAdmin`). Admin
   * versions independently of the consumer app, so it reads only this field;
   * a consumer-app cutoff never forces an admin update.
   */
  appVersionRequiredAdmin?: string;
}

export async function pingApi(): Promise<PingResponse> {
  return get<PingResponse>('/ping');
}
